module.exports = __webpack_public_path__ + "img/bg-mbl-C.78d9c02a.png";